module.exports = __webpack_public_path__ + "img/rules-bg.9038cbb3.png";